<wbo-edit-page #editPage [title]="model.data.description">
    <fui-rows [formGroup]="editPage.formGroup">
        <fui-row>
            <fui-two-columns>
                <fui-column>
                    <wbo-text-edit-control formControlName="code" [(ngModel)]="model.data.code"></wbo-text-edit-control>
                </fui-column>
                <fui-column>
                    <wbo-text-edit-control formControlName="name" [(ngModel)]="model.data.name"></wbo-text-edit-control>
                </fui-column>
            </fui-two-columns>
        </fui-row>
    </fui-rows>
</wbo-edit-page>
